import { Trans } from '@lingui/react';
import { Box } from '@startuptools/ui/Box';
import { Button } from '@startuptools/ui/Button';
import { Stack } from '@startuptools/ui/Stack';
import { Typography } from '@startuptools/ui/Typography';
import { SipShareSubscriptionNoteList } from '../../../common/components/documents/SipShareSubscriptionNoteList';
import { ShareIssueRegistrationForm } from '../../../common/components/documents/ShareIssueRegistrationForm';
import { GqlShareIssue, GqlShareIssueRegistration } from '../../../../graphql/base-types.graphql';
import { DisplayIdentity } from '@startuptools/business-ui/identity/Identity';
import { useNavigate } from '../../../../components/Navigate';
import { Link } from 'react-router-dom';
import { siShowDocumentsLink } from '../../../../components/Links';

export const SiStepDocuments = ({
  shareIssue,
  shareIssueRegistration,
}: {
  shareIssue: Pick<GqlShareIssue, 'id'>;
  shareIssueRegistration: Pick<GqlShareIssueRegistration, 'id' | 'description'> & {
    signatory?: DisplayIdentity | null;
  };
}) => {
  const { link } = useNavigate();

  return (
    <Stack gap={3}>
      <Typography level="h4">
        <Trans id="Documents" />
      </Typography>

      <ShareIssueRegistrationForm shareIssueId={shareIssue.id} shareIssueRegistration={shareIssueRegistration} />

      <SipShareSubscriptionNoteList shareIssueId={shareIssue.id} />

      <Box>
        <Button component={Link} to={link(siShowDocumentsLink(shareIssue))}>
          <Trans id="Go to overview" />
        </Button>
      </Box>
    </Stack>
  );
};
